import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.4566 1.1103C20.8543 1.31442 21.0683 1.75772 20.9806 2.19609L19.1474 11.3622L26.3511 14.0636C26.6638 14.1809 26.8973 14.4464 26.9736 14.7715C27.0499 15.0965 26.9589 15.4382 26.7311 15.6823L12.7311 30.6823C12.426 31.0091 11.9412 31.0938 11.5434 30.8897C11.1457 30.6855 10.9318 30.2422 11.0194 29.8039L12.8527 20.6377L5.64889 17.9363C5.33626 17.8191 5.10277 17.5535 5.02647 17.2285C4.95018 16.9034 5.04114 16.5617 5.26896 16.3177L19.269 1.31766C19.574 0.99084 20.0589 0.90618 20.4566 1.1103ZM7.75164 16.5888L14.3511 19.0636C14.8102 19.2358 15.0767 19.7153 14.9806 20.1961L13.671 26.744L24.2484 15.4111L17.6489 12.9363C17.1898 12.7642 16.9233 12.2846 17.0194 11.8039L18.329 5.25592L7.75164 16.5888Z" })
});
export default SvgLightning;
